import React from 'react'
import { Link } from 'react-router-dom'
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Homepage.scss'
import NavbarLogo from '../components/NavbarLogo/NavbarLogo'
import Button from '../components/Button/Button'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

import Image1 from '../assets/images/Image_1.png'

function Homepage() {
    const titleButton = "ENTRA"
    
    return (
        <>
            <Sidemenu path1="/chi-siamo" name1="Chi Siamo" path2="/progetto" name2="Progetto" path3="/community" name3="Community" path4="/supportaci" name4="Supportaci"/>
            <NavbarLogo />
            <section>
                <h1>Benvenuto su <br className="ritornoCapo"/>Fady!</h1>
                <img src={Image1} className="Image1" alt="FadyIMG" />
                <p>Unisciti alla nostra <b>community </b>
                e scopri un nuovo metodo per 
                <b> studiare insieme</b> e imparare 
                senza distrazioni.</p>
                <Link to="/stanze">
                    <Button title={titleButton} />
                </Link> 
            </section>
            <Footer />
        </>
    )
}

export default Homepage
